import { AttachMoney } from '@mui/icons-material'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useParams } from 'react-router-dom'
import { NavigateContext, M_Table, M_MessageBoard, M_Button, BufferService, LoadingContext, M_Fieldset } from 'src/M_Components'

export const ShippingConditionList = ({ roles, tablesOrder = [], onTablesOrderUpdate }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const [selectedLines, setSelectedLines] = useState([])
    const [refresh, setRefresh] = useState(false)

    const onPassContext = (e) => {
        if (e) sessionStorage.setItem('context', JSON.stringify(e))
    }

    const NewRoute = (url, label, operation, data) => {
        if (data) {
            ctx.passValue?.set('operation', operation)
            ctx.passValue?.set('row', data)
            ctx2.newTab(url, label)
        }
    }

    return (
        <M_Table
            entityName={'shippingcondition'}
            rolePermissions={roles}
            tablesOrder={tablesOrder}
            onTablesOrderUpdate={onTablesOrderUpdate}
            pageUrl={'shippingcondition'}
            removeContextItems={['Print', 'View', 'Copy']}
            onPassLine={(lines) => {
                setSelectedLines(lines)
                if (lines) sessionStorage.setItem('lines', JSON.stringify(lines))
            }}
            replaceFunctions={new Map([
                // ['Delete', (data) => {
                //     setQuoteToDelete(data)
                //     setOpenDeleteDialog(true)
                //     //deleteQuote(data)
                // }],
                ['Create', (data) => NewRoute('go/shippingConditionDetail', t('CreateShippingCondition'), 'create', {})],
                ['Edit', (data) => NewRoute('go/shippingConditionDetail', t('EditShippingCondition'), 'edit', data)]
            ])}
            onPassContext={onPassContext}
            refresh={refresh}
            setRefresh={setRefresh}
        />
    )
}
